import React, {useContext} from 'react';
import './GeneralUser.scss'
import {MqttClientContext} from "../../context/MqttClientContext";
import {UserInfoContext} from "../../context/UserInfoContext";
import * as Yup from "yup";
import {Formik, Form} from "formik";
import mqttRequests from "../../Utils/mqttRequests";
import FormikControl from "../FormTemplate/FormikControl";

//the page to edit some user group
function EditGroupUser(props) {

    const setEditGroup = props.setEditGroup;

    //variables to display the popups
    const groupUserName = localStorage.getItem("groupUserName");

    //the idAccount for mqtt
    const {idAccount} = useContext(UserInfoContext);

    //the mqtt client and source
    const {mqttClient, source} = useContext(MqttClientContext);

    //the initial values for formik
    const initialValues = {
        newName: localStorage.getItem("groupUserName"),
        newDescription: localStorage.getItem("groupUserDescription"),
    };

    //the yup validation schema
    const validationSchema = Yup.object({
        newName: Yup.string().required("Required"),
    });

    //method to communicate with mqtt
    const submitMethod = (value) => {

        //generate operation code
        let operation = mqttRequests.generateOperationCode("editGroupUser");

        //create json to publish
        let data = '{"operation":"' + operation + '", "source":"' + source + '", "idAccount":"' + idAccount + '", "nameGroupUser":"' + groupUserName +
            '", "newName":"' + value.newName + '", "newDescr":"' + value.newDescription + '"}';

        //subscribe to the channel to wait for the mqtt response
        mqttRequests.subscribe(mqttClient, "source/" + source + "/editGroupUser");

        //publish a demand to edit the user group
        mqttRequests.publish(mqttClient, "user/editGroupUser", data);

        //get group users again (refresh)
        operation = mqttRequests.generateOperationCode("getGroupUser");
        data = '{"operation":"' + operation + '", "source":"' + source + '", "idAccount":"' + idAccount + '"}';
        mqttRequests.subscribe(mqttClient, "source/" + source + "/getGroupUser");
        mqttRequests.publish(mqttClient, "user/getGroupUser", data);
    };

    return(
        <div>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={submitMethod}
            >
                {() => {
                    return(
                        <Form>
                            <FormikControl control="input" type="text" label="Name: " name="newName"/>
                            <FormikControl control="textarea" type="text" label="Description: " name="newDescription"/>
                            <button type="submit" className="UserButton">Validate</button>
                            <button type="button" className="UserButton" onClick={() => setEditGroup('')}>Cancel</button>
                        </Form>
                    )
                }}
            </Formik>
        </div>
    )
}

export default EditGroupUser;